import type { Course, Cuisine } from '@fewerbags/schema';
import { courseBadgeClass, cuisineBadgeClass } from '../../lib/recipeVisuals';
import { courseLabel, cuisineLabel } from '../../pages/recipes/taxonomy';

/**
 * Coloured cuisine and course badges (D26). Courses are solid pills in the
 * same colour family as the recipe's photo placeholder; cuisines are outlined
 * pills coloured by region. Free-form tags keep their own soft-teal chips, so
 * the three read as different things.
 */
export function CuisineCourseBadges({
  cuisines,
  courses,
  size = 'sm',
}: {
  cuisines: readonly Cuisine[];
  courses: readonly Course[];
  size?: 'xs' | 'sm';
}) {
  if (cuisines.length === 0 && courses.length === 0) return null;
  const text = size === 'xs' ? 'text-xs' : 'text-xs sm:text-sm';
  return (
    <ul className="flex flex-wrap gap-1.5" aria-label="Cuisine and course">
      {courses.map((key) => (
        <li
          key={`course-${key}`}
          className={`rounded-full px-2.5 py-0.5 font-semibold ${courseBadgeClass(key)} ${text}`}
        >
          <span className="sr-only">Course: </span>
          {courseLabel(key)}
        </li>
      ))}
      {cuisines.map((key) => (
        <li
          key={`cuisine-${key}`}
          className={`rounded-full px-2.5 py-0.5 font-medium ${cuisineBadgeClass(key)} ${text}`}
        >
          <span className="sr-only">Cuisine: </span>
          {cuisineLabel(key)}
        </li>
      ))}
    </ul>
  );
}
